export default "__VITE_ASSET__afz5Y_y8__"